/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Practice } from '../../models/practice';

export interface UserPracticesGetAllSourcePracticesOfMappedUser$Params {
  userId?: number;
}

export function userPracticesGetAllSourcePracticesOfMappedUser(http: HttpClient, rootUrl: string, params?: UserPracticesGetAllSourcePracticesOfMappedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Practice>>> {
  const rb = new RequestBuilder(rootUrl, userPracticesGetAllSourcePracticesOfMappedUser.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Practice>>;
    })
  );
}

userPracticesGetAllSourcePracticesOfMappedUser.PATH = '/mappeduserpracticesforsource';
